import { useEffect } from 'react';
import { usePushNotifications } from '@/hooks/usePushNotifications';

export const PushNotificationProvider = ({ children }: { children: React.ReactNode }) => {
  const { isSupported, token } = usePushNotifications();

  useEffect(() => {
    if (isSupported && token) {
      console.log('Push notifications initialized with token');
    }
  }, [isSupported, token]);

  return <>{children}</>;
};
